<template>
  <div style="display: inline-block">
    <el-button type="danger" style="margin-left: 10px;" size="mini" @click="add">申请发布</el-button>
    <el-dialog
      title="申请发布"
      :visible.sync="dialogVisible"
      width="45%"
    >
      <el-card>
        <p>
          <span
            v-if="lastRecord.status===1"
            style="color:#909399"
          >待申请</span>
          <span v-else :style="{'color':colorArr[lastRecord.status]}">{{ statTextArr[lastRecord.status] }}</span>
        </p>
        <p>最近一次发布时间:{{ lastRecord.created }}</p>
        <p>最后一次审核进度:{{ lastRecord.updated }} <span v-if="lastRecord.created !== '-'" :style="{'color':colorArr[lastRecord.status]}">{{ statTextArr[lastRecord.status] }}</span></p>
        <el-form>
          <el-form-item>
            <el-input v-model="form.mark" :disabled="lastRecord.status ===0 " placeholder="申请备注" :rows="4" type="textarea" />
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="lastRecord.status ===0 " @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCacheClearLast, updateCacheClearCfg } from '@/api/config/clear-cache-cfg'

export default {
  name: 'ClearCacheApply',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      lastRecord: {
        created: '-',
        updated: '-',
        status: 1
      },
      form: {
        mark: '',
        url: ''
      },
      colorArr: ['#E6A23C', '#67C23A', '#F56C6C'],
      statTextArr: ['审核中', '已审核', '已拒绝']
    }
  },
  created() {
    this.form.url = this.$router.resolve(this.$route).href
    this.getLastRecord()
  },
  methods: {
    add() {
      this.dialogVisible = true
      this.getLastRecord()
    },
    getLastRecord() {
      if (this.url) {
        this.form.url = this.url
      }
      getCacheClearLast({ url: this.form.url }).then(res => {
        if (res.data && res.data.id > 0) {
          this.lastRecord.created = res.data.created_at
          this.lastRecord.status = res.data.status
          this.lastRecord.updated = res.data.approver_nick_name
        }
      })
    },
    onSubmit() {
      if (this.url) {
        this.form.url = this.url
      }
      if (!this.form.url) {
        this.msgError('url获取失败!')
        return
      }
      this.dialogVisible = false
      updateCacheClearCfg(this.form).then(res => {
        this.msgSuccess('提交成功!')
        setTimeout(() => {
          this.$router.push('/config/apply_log/index')
        }, 600)
      })
    }
  }
}
</script>

<style scoped>

</style>
